import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppConfig } from 'app/app.config';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoCustomer } from 'app/shared/models/customer/dto-customer.model';
import { IDtoCompany } from 'app/shared/models/organization/dto-company.model';
import { IDtoCustomerType } from 'app/shared/models/customer/dto-customer-type.model';
import { PositionService } from '../position.service';
import { ValidatorService } from 'app/shared/services/validator.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BudgetService } from '../budget.service';
import { RecruitmentService } from '../../recruitment/recruitment.service';
import { ISelect } from 'app/shared/models/select.model';
import { map } from 'rxjs/operators';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';
import { IMyDateModel } from 'angular-mydatepicker';
import { IDtoCatalogPosition } from 'app/shared/models/quote/catalog-position.model';
import { IDtoBudgetDetail } from 'app/shared/models/quote/budget-detail.model';
import { IDtoBudgetDistribution } from 'app/shared/models/quote/budget-distribution.model';
import { IDtoPaymentConcept } from 'app/shared/models/position/dto-payment-concept.model';
import { IDtoExpenseDetail } from 'app/shared/models/quote/expense-detail.model';
import { SecurityService } from 'app/shared/services/security.service';
import { IUser } from 'app/shared/models/user.model';
import { EnumBudgetStatus } from 'app/shared/enums/budget-status.enum';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalReasonComponent } from 'app/views/modales/common/modal-reason.component';
import { ModalNotesComponet } from 'app/views/modales/budget/notes/modal-notes.component';
import { ModalBudgetApproverComponent } from 'app/views/modales/customer/budget-approver/modal-budget-approver.component';
import { MatRadioChange } from '@angular/material';
import { AdministrationService } from '../administration.service';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { IdentityService } from '../../security/identity.service';
import { IDtoBonusDetail } from 'app/shared/models/quote/bonus-detail.model';
@Component({
    selector: '[app-budget]',
    styleUrls: ['budget.style.scss'],
    templateUrl: 'budget.template.html'
})
export class BudgetComponent implements OnDestroy, OnInit {
    private configModal = {
        backdrop: true,
        ignoreBackdropClick: true,
        keyboard: false,
    };
    /**Validadores */
    private validator = ValidatorService;
    private fsaFlags = [false];
    private flag = false;
    private errorMessages: any;

    public nav: any;
    private customer: IDtoCustomer;
    private action = 'add';
    /**Catalogos */
    private catalogPlanTrademarks: Observable<IDtoCatalog[]>;
    private catalogPlanTypes: Observable<IDtoCatalog[]>;
    private catalogBudgetTypes: Observable<IDtoCatalog[]>;
    private catalogProjectCustomers: Observable<IDtoCatalog[]>;
    private catalogStates: Observable<ISelect[]>;
    private catalogTowns: Observable<ISelect[]>;
    private positions: IDtoCatalogPosition[];
    private catalogProductExpenses: Observable<IDtoCatalog[]>;
    private catalogExpenseTypes: Observable<IDtoCatalog[]>;
    private catalogInvoiceConcepts: Observable<IDtoCatalog[]>;
    private catalogCustomerCommissions: IDtoCatalog[];
    private formGeneralData: FormGroup;
    private formCreateBudget: FormGroup;
    private formCreateExpense: FormGroup;
    private formCreateBonus: FormGroup;
    private budgetDetails = new Array() as IDtoBudgetDetail[];
    private expenseDetails = new Array() as IDtoExpenseDetail[];
    private bonusDetails = new Array() as IDtoBonusDetail[];
    private budget: IDtoBudget;
    private budgetStatusUpdate: IDtoBudget;
    private budgetDistributionTowns = new Array() as IDtoBudgetDistribution[];
    private budgetDistributionPositions = new Array() as IDtoBudgetDistribution[];
    private budgetSalaryDistributionConcepts = new Array() as IDtoPaymentConcept[];
    private budgetSalaryDistributionPositions = new Array() as IDtoBudgetDistribution[];
    @ViewChild('swalAdd', { static: false }) private swalAdd: SwalComponent;
    @ViewChild('swalApprove', { static: false }) private swalApprove: SwalComponent;
    @ViewChild('swalSentApproval', { static: false }) private swalSentApproval: SwalComponent;
    @ViewChild('swalRejectBudget', { static: false }) private swalRejectBudget: SwalComponent;
    @ViewChild('confirmSwal', { static: false }) private confirmSwal: SwalComponent;
    @ViewChild('swalApprovalSummary', { static: false }) private swalApprovalSummary: SwalComponent;
    @ViewChild('swalRefusedSummary', { static: false }) private swalRefusedSummary: SwalComponent;
    @ViewChild('tab1', { static: false }) private tab1;
    public resetCustomerId: Subject<number> = new Subject<number>();
    subtotal: number = 0;
    discount: number = 0;
    subtotalDiscount: number = 0;
    iva: number = 0;
    total: number = 0;
    subtotalExp: number = 0;
    discountExp: number = 0;
    subtotalDiscountExp: number = 0;
    ivaExp: number = 0;
    totalExp: number = 0;
    subtotalBonus: number = 0;
    ivaBonus: number = 0;
    totalBonus: number = 0;
    private profile: string;
    private user: IUser;
    private status: string;
    private modalRef: BsModalRef;
    private ivaPercentage: number;
    private module: string;
    public constructor(private router: Router
        , private configGeneral: AppConfig
        , private modalService: BsModalService
        , private formBuilder: FormBuilder
        , private positionService: PositionService
        , private budgetService: BudgetService
        , private configurationService: ConfigurationService
        , private spinner: NgxSpinnerService
        , private route: ActivatedRoute
        , private recruitmentService: RecruitmentService
        , private securityService: SecurityService
        , private administrationService: AdministrationService
        , private identityService: IdentityService) {
        this.nav = document.querySelector('nav.navbar');
        this.profile = this.securityService.getProfileStorage('BudgetCreation');
        this.user = this.securityService.getUserDataStorage();

        this.customer = {} as IDtoCustomer;
        this.customer.payCompany = {} as IDtoCompany;
        this.customer.customerType = {} as IDtoCustomerType;
        if (this.configurationService.isReady) {
            this.getCatalogs();
            this.getIvaPercentage();
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.getCatalogs();
                this.getIvaPercentage();
            });
        }
        this.initializeFormGeneralData();
        this.initializeFormCreateBudget();
        this.initializeFormCreateExpense();
        this.initializeFormCreateBonus();
    }

    ngOnInit(): any {
        this.module = this.route.snapshot.data.expectedModule;
        if (this.profile == 'Cliente') {
            this.formGeneralData.disable();
        }
        //this.nav.className += ' white-bg';
        this.budget = {} as IDtoBudget;
        this.budget.status = 0;
        this.route.params.subscribe((params) => {
            if (params['id']) {
                setTimeout(() => {
                    this.action = params['action'];
                    this.getBudget(params['id']);
                }, 2);

            }
        });
        this.onChangesFormGeneralData();
    }
    private initializeFormGeneralData() {
        this.formGeneralData = this.formBuilder.group({
            customerId: [null, Validators.required],
            duration: [null, Validators.required],
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
            planTypeId: [null, Validators.required],
            budgetTypeId: [null, Validators.required],
            invoiceConceptId: [null, Validators.required],
            projectCustomerId: [null],
            projectId: [null],
            planTrademarkId: [null],
            comments: [null, [Validators.maxLength(255)]]
        });
    }
    private initializeFormCreateBudget() {
        this.formCreateBudget = this.formBuilder.group({
            positionId: [null, Validators.required],
            stateId: [null, Validators.required],
            townId: [null, Validators.required],
            quantity: [1, Validators.required],
            duration: [null, Validators.required],
            discountPercentage: [0],
            projectCustomerId: [null],
            planTrademarkId: [null]
        });
    }
    private initializeFormCreateExpense() {
        this.formCreateExpense = this.formBuilder.group({
            productId: [null, Validators.required],
            expenseTypeId: [null, Validators.required],
            cost: [null, Validators.required],
            quantity: [1, Validators.required],
            duration: [null],
            description: [null, [Validators.required, Validators.maxLength(255)]],
            discountPercentage: [0],
            distributionType: [null, [Validators.required]],
            projectCustomerId: [null]
        });
    }
    private initializeFormCreateBonus() {
        this.formCreateBonus = this.formBuilder.group({
            projectCustomerId: [null],
            positionId: [null, Validators.required],
            customerCommissionId: [null, Validators.required],
            amount: [null, Validators.required],
            quantity: [1, Validators.required],
            duration: [null],
            description: [null, [Validators.required, Validators.maxLength(255)]]
        });
    }
    private onChangesFormGeneralData(): void {
        this.formGeneralData.get('duration').valueChanges.subscribe(val => {
            this.formCreateBudget.get('duration').setValue(val);
        });
    }
    private receiveCustomer(customer: IDtoCustomer) {
        this.positions = [] as IDtoCatalogPosition[];
        this.formCreateBudget.get('positionId').setValue(null);
        this.formCreateBudget.get('projectCustomerId').setValue(null);
        this.formCreateBudget.get('planTrademarkId').setValue(null);
        if (this.action == 'add') {
            this.catalogProjectCustomers = null;
            this.formGeneralData.get('projectCustomerId').setValue(null);
            this.catalogPlanTrademarks = null;
            this.formGeneralData.get('planTrademarkId').setValue(null);
            if (customer !== undefined) {
                this.customer = customer;
                this.validateProjectAndPlan();
                this.positionService.getCatalogVariableCustomerCommissionsByCustomerId(this.customer.id).subscribe(res => { this.catalogCustomerCommissions = res; });
                switch (this.profile) {
                    case 'Ejecutivo':
                        this.catalogProjectCustomers = this.budgetService.getCatalogProjectsByCustomerIdAndEjecutive(this.customer.id, this.user.userId);
                        break;
                    default:
                        this.catalogProjectCustomers = this.budgetService.getCatalogProjectCustomersByCustomerId(this.customer.id);
                        break;
                }
                if (this.customer.staffTypeName == 'Campo') {
                    this.getPositionsByCustomerId(this.customer.id);
                }
            }
        } else {
            if (customer !== undefined) {
                this.customer = customer;
                this.validateProjectAndPlan();
                this.positionService.getCatalogVariableCustomerCommissionsByCustomerId(this.customer.id).subscribe(res => { this.catalogCustomerCommissions = res; });
                if (this.customer.staffTypeName == 'Campo') {
                    this.getPositionsByCustomerId(this.customer.id);
                }
            }
        }
    }
    private validateProjectAndPlan(): void {
        if (this.customer.staffTypeName != 'Oficina') {
            this.formGeneralData.get('projectCustomerId').setValidators([Validators.required]);
            this.formGeneralData.get('planTrademarkId').setValidators([Validators.required]);
        } else {
            this.formGeneralData.get('projectCustomerId').setValidators(null);
            this.formGeneralData.get('planTrademarkId').setValidators(null);
        }
        this.formGeneralData.get('projectCustomerId').updateValueAndValidity();
        this.formGeneralData.get('planTrademarkId').updateValueAndValidity();
    }
    private getPositionsByCustomerId(customerId: number): void {
        this.positionService.getPositionsByCustomerId(customerId).subscribe(res => {
            if (res.isCorrect) {
                this.positions = res.data as IDtoCatalogPosition[];
                this.formCreateBudget.get('positionId').setValue(null);
            }
        })
    }
    private getPositionsByProjectId(customerId: number): void {
        this.positionService.getPositionsByProjectId(customerId).subscribe(res => {
            if (res.isCorrect) {
                this.positions = res.data as IDtoCatalogPosition[];
                this.formCreateBudget.get('positionId').setValue(null);
            }
        })
    }
    private getIvaPercentage(): void {
        this.administrationService.getIvaPercentage().subscribe(res => {
            this.ivaPercentage = res;
        })
    }
    private getCatalogTowns(dto: ISelect): void {
        this.catalogTowns = null;
        this.formCreateBudget.get('townId').setValue(null);
        if (dto === undefined) {
            return;
        }
        this.catalogTowns = this.recruitmentService.getCatalogTownsWithStructureByStateId(dto.id);
    }
    private getCatalogs(): void {
        this.catalogPlanTypes = this.budgetService.getCatalogPlanTypes();
        this.catalogStates = this.recruitmentService.getCatalogStates();
        this.catalogExpenseTypes = this.budgetService.getCatalogExpenseTypes();
        this.catalogProductExpenses = this.positionService.getCatalogProductExpenses();
        this.catalogBudgetTypes = this.budgetService.getCatalogBudgetTypes();
        this.catalogInvoiceConcepts = this.budgetService.getCatalogInvoiceConcepts();
    }
    private changeProjectCustomer(dto: IDtoCatalog): void {
        if (dto === undefined) {
            this.catalogPlanTrademarks = null;
            this.formGeneralData.get('planTrademarkId').setValue(null);
            return;
        }
        this.catalogPlanTrademarks = this.budgetService.getCatalogPlanTrademarksByProjectCustomerId(dto.id);
        if (this.customer.staffTypeName == 'Oficina') {
            this.getPositionsByProjectId(dto.id);
        }
    }
    public ngOnDestroy(): any {
        this.nav.classList.remove('white-bg');
    }
    private addPositionToBudget(): void {
        if (!this.formCreateBudget.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formCreateBudget);
            return;
        }

        let item = this.formCreateBudget.value as IDtoBudgetDetail;
        let detail = this.budgetDetails.filter(p => p.positionId == item.positionId && p.townId == item.townId && p.duration == item.duration)[0];
        if (detail != null) {
            detail.quantity = +item.quantity;//+detail.quantity + +item.quantity;
            detail.totalCost = Math.round((detail.dailyCost * +detail.quantity) * 100) / 100;
            let des = detail.totalCost * detail.discountPercentage / 100;
            detail.discount = Math.round(des * 100) / 100;
            detail.totalFinalCost = Math.round((detail.totalCost - detail.discount) * 100) / 100;
        } else {


            const sta = this.catalogStates.pipe(map(items => items.filter(p => p.id == item.stateId.toString())));
            sta.subscribe(val => {
                item.stateName = val[0].text;
            });
            const tow = this.catalogTowns.pipe(map(items => items.filter(p => p.id == item.townId.toString())));
            tow.subscribe(val => {
                item.townName = val[0].text;
            });

            const pos = this.positions.filter(p => p.id == item.positionId);
            //const parts = pos[0].tradename.split('-');
            item.positionName = pos[0].tradename;//parts.slice(1).join('-');

            item.dailyCost = +pos[0].positionDetails.filter(d => d.name == 'dailyCost')[0].value;
            item.totalCost = Math.round((item.dailyCost * +item.quantity) * 100) / 100;
            let des = item.totalCost * item.discountPercentage / 100;
            item.discount = Math.round(des * 100) / 100;
            item.totalFinalCost = Math.round((item.totalCost - item.discount) * 100) / 100;

            item.status = 'add';
            this.budgetDetails.unshift(item);
        }
        this.formCreateBudget.get('quantity').setValue(1);
        this.formCreateBudget.get('discountPercentage').setValue(0);
    }
    private addExpenseToBudget(): void {
        if (!this.formCreateExpense.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formCreateExpense);
            return;
        }
        if (this.customer.expensesPercentage == undefined) {
            this.configGeneral.newToast('Validación', 'Seleccione un cliente para poder continuar', 'error');
            return;
        }
        let item = this.formCreateExpense.value as IDtoExpenseDetail;

        if (item.duration == 0) {
            this.configGeneral.newToast('Validación', 'Duración no puede ser 0 días', 'warning');
            this.formCreateExpense.get('duration').setValue(null);
            return;
        }

        if (this.customer.staffTypeName == 'Oficina' && item.projectCustomerId == undefined) {
          this.configGeneral.newToast('Validación', 'Seleccione un proyecto para continuar', 'warning');
          return;
        }

        {
            const prod = this.catalogProductExpenses.pipe(map(items => items.filter(p => p.id == item.productId)));
            prod.subscribe(val => {
                item.productName = val[0].name;
            });

            const exp = this.catalogExpenseTypes.pipe(map(items => items.filter(p => p.id == item.expenseTypeId)));
            exp.subscribe(val => {
                item.expenseTypeName = val[0].name;
            });
            if (item.projectCustomerId != undefined){
            const expProyect = this.catalogProjectCustomers.pipe(map(items => items.filter(p => p.id == item.projectCustomerId)));
            expProyect.subscribe(val => {
                item.projectCustomerName = val[0].name;
            });
            };

            item.expensesPercentage = this.customer.expensesPercentage;
            item.expensesCost = Math.round((item.cost * item.expensesPercentage / 100) * 100) / 100;
            item.unitCost = Math.round((+item.cost + +item.expensesCost) * 100) / 100;
            if (item.duration != null) {
                item.totalCost = Math.round((item.unitCost * item.quantity * item.duration) * 100) / 100;
                item.discount = 0;
                if (item.discountPercentage > 0) {
                    let des = item.totalCost / ((+item.discountPercentage + 100) / 100);
                    item.discount = Math.round((item.totalCost - des) * 100) / 100;
                    item.totalFinalCost = Math.round(des * 100) / 100;
                } else {
                    item.totalFinalCost = Math.round(item.totalCost * 100) / 100;
                }

            } else {
                item.totalCost = Math.round((item.unitCost * item.quantity) * 100) / 100;
                item.discount = 0;
                if (item.discountPercentage > 0) {
                    let des = item.totalCost / ((+item.discountPercentage + 100) / 100);
                    item.discount = Math.round((item.totalCost - des) * 100) / 100;
                    item.totalFinalCost = Math.round(des * 100) / 100;
                } else {
                    item.totalFinalCost = Math.round((item.totalCost - item.discount) * 100) / 100;
                }
            }

            item.status = 'add'
            this.formCreateExpense.get('quantity').setValue(1);
            this.formCreateExpense.get('discountPercentage').setValue(0);
            this.expenseDetails.push(item);
            this.calculateTotalExpenses();
        }
    }
    private addBonusToBudget(): void {
        if (!this.formCreateBonus.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formCreateBonus);
            return;
        }
        if (this.customer.expensesPercentage == undefined) {
            this.configGeneral.newToast('Validación', 'Seleccione un cliente para poder continuar', 'error');
            return;
        }
        let item = this.formCreateBonus.value as IDtoBonusDetail;
        let detail = this.bonusDetails.filter(p => p.positionId == item.positionId && p.customerCommissionId == item.customerCommissionId)[0];
        if (detail != null) {
            this.confirmSwal.title = 'Ya existe un registro con los datos seleccionados. ¿Seguro que desea reemplazarlo con los nuevos valores?';
            this.confirmSwal.show().then((result) => {
                if (result.value) {
                    detail.quantity = +item.quantity;
                    detail.amount = +item.amount;
                    detail.duration = +item.duration;
                    detail.description = item.description;
                    detail.socialCharge = Math.round((detail.socialChargePercentage * detail.amount / 100) * 100) / 100;
                    detail.agency = Math.round(((detail.amount + detail.socialCharge) * detail.agencyPercentage / 100) * 100) / 100;
                    detail.totalCost = Math.round((detail.amount + detail.socialCharge + detail.agency) * 100) / 100;
                    detail.subTotal = Math.round((detail.quantity * detail.totalCost) * 100) / 100;
                    detail.iva = Math.round((detail.subTotal * this.ivaPercentage / 100) * 100) / 100;
                    detail.total = Math.round((detail.subTotal + detail.iva) * 100) / 100;
                    this.calculateTotalBonus();
                }
            });
        } else {
            const pos = this.positions.filter(p => p.id == item.positionId);
            item.positionName = pos[0].tradename;
            const exp = this.catalogCustomerCommissions.filter(p => p.id == item.customerCommissionId)[0];
            item.customerCommissionName = exp.name;
            item.socialChargePercentage = +pos[0].positionDetails.filter(d => d.name == 'socialChargePercentage')[0].value;
            item.socialCharge = Math.round((item.socialChargePercentage * +item.amount / 100) * 100) / 100;
            item.agencyPercentage = this.customer.agencyPercentage;
            item.agency = Math.round(((+item.amount + item.socialCharge) * item.agencyPercentage / 100) * 100) / 100;
            item.totalCost = Math.round((+item.amount + item.socialCharge + item.agency) * 100) / 100;
            item.subTotal = Math.round((+item.quantity * item.totalCost) * 100) / 100;
            item.iva = Math.round((item.subTotal * this.ivaPercentage / 100) * 100) / 100;
            item.total = Math.round((item.subTotal + item.iva) * 100) / 100;;
            item.status = 'add';
            this.bonusDetails.unshift(item);
        }
        this.calculateTotalBonus();
    }
    private getBudget(budgetId: string): void {
        this.spinner.show()
        this.budgetService.getBudget(budgetId)
            .subscribe(
                (x) => {
                    this.budget = x.data as IDtoBudget;

                    if (this.profile == 'Cliente'){
                      if (this.budget.status == 2){
                        this.swalApprovalSummary.title = 'Presupuesto aprobado';
                      this.swalApprovalSummary.show();
                      this.spinner.hide();
                      return;
                      }
                      if (this.budget.status == 3){
                        this.swalRefusedSummary.title = 'Presupuesto rechazado';
                      this.swalRefusedSummary.show();
                      this.spinner.hide();
                      return;
                      }
                    }

                    this.ivaPercentage = this.budget.ivaPercentage;
                    this.formGeneralData.patchValue(this.budget);
                    this.setDateInit(this.budget.startDate);
                    this.setDateEnd(this.budget.endDate);
                    this.budgetDetails = this.budget.budgetDetails;
                    this.expenseDetails = this.budget.expenseDetails;
                    this.bonusDetails = this.budget.bonusDetails;
                    this.catalogProjectCustomers = this.budgetService.getCatalogProjectCustomersByCustomerId(this.budget.customerId);
                    if (this.budget.projectCustomerId != null) {
                        this.catalogPlanTrademarks = this.budgetService.getCatalogPlanTrademarksByProjectCustomerId(this.budget.projectCustomerId);
                    }
                    this.getPositionsByCustomerId(this.budget.customerId);
                    this.resetCustomerId.next(this.budget.customerId);
                    this.showPersonalDistribution();
                    this.calculateTotalExpenses();
                    this.calculateTotalBonus();
                    this.spinner.hide();
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private showPersonalDistribution(): void {
        this.budgetService.getBudgetPositionDistribution(this.budget.id)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.budgetDistributionTowns = x.data[0] as IDtoBudgetDistribution[];
                        this.budgetDistributionPositions = x.data[1] as IDtoBudgetDistribution[];
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
        this.budgetService.getBudgetSalaryDistribution(this.budget.id)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.budgetSalaryDistributionConcepts = x.data[0] as IDtoPaymentConcept[];
                        this.budgetSalaryDistributionPositions = x.data[1] as IDtoBudgetDistribution[];
                        this.calculateTotalDetailBudget();
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private removePositionFromBudget(item: IDtoBudgetDetail): void {
        if (item.id != undefined) {
            item.status = 'delete'
        } else {
            let index = this.budgetDetails.indexOf(item)
            if (index > -1) {
                this.budgetDetails.splice(index, 1);
            }
        }
    }
    private removeExpenseFromBudget(item: IDtoExpenseDetail): void {
        if (item.id != undefined) {
            item.status = 'delete'
        } else {
            let index = this.expenseDetails.indexOf(item)
            if (index > -1) {
                this.expenseDetails.splice(index, 1);
            }
        }
        this.calculateTotalExpenses();
    }
    private removeBonusFromBudget(item: IDtoBonusDetail): void {
        if (item.id != undefined) {
            item.status = 'delete'
        } else {
            let index = this.bonusDetails.indexOf(item)
            if (index > -1) {
                this.bonusDetails.splice(index, 1);
            }
        }
        this.calculateTotalBonus();
    }
    private calculateTotal(): number {
        let sum: number = 0;
        this.budgetDetails.forEach(a => sum += +a.totalCost);
        return sum;
    }
    private calculateTotalDetailBudget(): void {
        this.subtotal = 0;
        this.discount = 0;
        this.subtotalDiscount = 0;
        this.iva = 0;
        this.total = 0;
        this.budgetSalaryDistributionPositions.forEach(element => {
            element.items.filter(x => x.name == 'finalSubtotal').forEach(a => this.subtotal += +a.quantity);
            element.items.filter(x => x.name == 'finalDiscount').forEach(a => this.discount += +a.quantity);
            element.items.filter(x => x.name == 'finalSubtotalDiscount').forEach(a => this.subtotalDiscount += +a.quantity);
            element.items.filter(x => x.name == 'finalIva').forEach(a => this.iva += +a.quantity);
            element.items.filter(x => x.name == 'finalTotal').forEach(a => this.total += +a.quantity);
        });

    }
    private calculateTotalExpenses(): void {
        this.subtotalExp = 0;
        this.discountExp = 0;
        this.subtotalDiscountExp = 0;
        this.ivaExp = 0;
        this.totalExp = 0;
        this.expenseDetails.filter(x => x.status != 'delete').forEach(a => this.subtotalExp += +a.totalCost);
        this.expenseDetails.filter(x => x.status != 'delete').forEach(a => this.discountExp += +a.discount);
        this.subtotalDiscountExp = +this.subtotalExp - +this.discountExp;
        this.ivaExp = (this.subtotalDiscountExp * this.ivaPercentage) / 100;
        this.totalExp = this.subtotalDiscountExp + this.ivaExp;

    }
    private calculateTotalBonus(): void {
        this.subtotalBonus = 0;
        this.ivaBonus = 0;
        this.totalBonus = 0;
        this.bonusDetails.filter(x => x.status != 'delete').forEach(a => this.subtotalBonus += +a.subTotal);
        this.ivaBonus = (this.subtotalBonus * this.ivaPercentage) / 100;
        this.totalBonus = this.subtotalBonus + this.ivaBonus;

    }
    private submit(): void {
        if (!this.formGeneralData.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formGeneralData);
            return;
        }
        this.swalAdd.title = '¿Seguro que desea guardar el presupuesto seleccionado?';
        this.swalAdd.show();
    }
    private submitSentApproval(approverUserId: string): void {
        if (!this.formGeneralData.valid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formGeneralData);
            return;
        }
        this.budgetStatusUpdate = {} as IDtoBudget;
        this.budgetStatusUpdate.approverUserId = approverUserId;
        this.budgetStatusUpdate.id = this.budget.id;
        this.budgetStatusUpdate.status = EnumBudgetStatus.Approval;
        this.budgetStatusUpdate.subtotal = this.subtotalDiscount + this.subtotalDiscountExp;
        this.budgetStatusUpdate.iva = this.iva + this.ivaExp;
        this.budgetStatusUpdate.total = this.total + this.totalExp;
        this.budgetStatusUpdate.billCompanyId = this.customer.billCompanyId;
        this.swalSentApproval.title = '¿Seguro que desea enviar a aprobación el presupuesto seleccionado?';
        this.swalSentApproval.show();
    }
    private submitApprove(): void {
        if (this.formGeneralData.invalid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formGeneralData);
            return;
        }
        this.budgetStatusUpdate = {} as IDtoBudget;
        this.budgetStatusUpdate.id = this.budget.id;
        this.budgetStatusUpdate.status = EnumBudgetStatus.Approved;
        this.swalApprove.title = '¿Seguro que desea aprobar el presupuesto seleccionado?';
        this.swalApprove.show();
    }
    private submitRejectBudget(rejectionReason: string): void {
        if (this.formGeneralData.invalid) {
            this.configGeneral.newToast('Validación', 'Capture toda la información requerida para poder continuar', 'warning');
            this.touchedControls(this.formGeneralData);
            return;
        }
        this.budgetStatusUpdate = {} as IDtoBudget;
        this.budgetStatusUpdate.id = this.budget.id;
        this.budgetStatusUpdate.status = EnumBudgetStatus.Rejected;
        this.budgetStatusUpdate.rejectionReason = rejectionReason;
        this.swalRejectBudget.title = '¿Seguro que desea rechazar el presupuesto seleccionado?';
        this.swalRejectBudget.show();
    }
    private save(): void {
        let budget = this.mapValues();
        switch (this.action) {
            case 'add':
                this.addBudget(budget);
                break;
            case 'update':
                this.updateBudget(budget);
                break;
        }
    }
    private addBudget(dto: IDtoBudget): void {
        this.spinner.show();
        this.budgetService.addBudget(dto)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.budget = x.data as IDtoBudget;
                        this.budgetDetails = this.budget.budgetDetails;
                        this.expenseDetails = this.budget.expenseDetails;
                        this.bonusDetails = this.budget.bonusDetails;
                        this.action = 'update'
                        this.setDateInit(this.budget.startDate);
                        this.setDateEnd(this.budget.endDate);
                        this.showPersonalDistribution();
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.addModuleLog(this.budget.id, 'new');
                        this.spinner.hide();
                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                        this.spinner.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private changeStatusBudget(): void {
        if (this.budget.id == undefined) {
            this.configGeneral.newToast('Validación', 'Guarde primeramente el presupuesto para poder aprobarlo', 'warning');
            return;
        }
        this.spinner.show();
        this.budgetService.changeStatusBudget(this.budgetStatusUpdate)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.budget.status = this.budgetStatusUpdate.status;
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.spinner.hide();
                        this.addModuleLog(this.budget.id, EnumBudgetStatus[this.budgetStatusUpdate.status]);

                    } else {
                        this.configGeneral.newToast('Error', x.message, 'error');
                        this.spinner.hide();
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private approveBudget(id: string): void {
      let dto = {} as IDtoCatalog;
      dto.name = this.budget.id.toString();
      this.spinner.show()
      this.budgetService.approveBudget(dto)
        .subscribe(
          (x) => {
            if (x.isCorrect) {
                  this.swalApprovalSummary.title = 'Presupuesto aprobado';
                  this.swalApprovalSummary.show()
            } else {
              this.configGeneral.newToast('Error', x.message, 'error');
                        this.spinner.hide();
            }
            this.spinner.hide();
          },
          (errMessage) => this.errorMessages = errMessage.messages);
    }
    private changeDistributionType($event: MatRadioChange) {
        if ($event.value == 1) {
            this.formCreateExpense.get('duration').setValidators([Validators.required]);
            this.formCreateExpense.get('duration').enable();
        } else {
            this.formCreateExpense.get('duration').setValidators(null);
            this.formCreateExpense.get('duration').setValue(null);
            this.formCreateExpense.get('duration').disable();
        }
        this.formCreateExpense.get('duration').updateValueAndValidity();
    }
    private updateBudget(dto: IDtoBudget): void {
        this.spinner.show();
        this.budgetService.updateBudget(dto)
            .subscribe(
                (x) => {
                    if (x.isCorrect) {
                        this.budget = x.data as IDtoBudget;
                        this.budgetDetails = this.budget.budgetDetails;
                        this.expenseDetails = this.budget.expenseDetails;
                        this.bonusDetails = this.budget.bonusDetails;
                        this.setDateInit(this.budget.startDate);
                        this.setDateEnd(this.budget.endDate);
                        this.showPersonalDistribution();
                        this.spinner.hide();
                        this.configGeneral.newToast('Éxito', x.message, 'success');
                        this.addModuleLog(this.budget.id, 'update');
                    } else {
                        this.spinner.hide();
                        this.configGeneral.newToast('Error', x.message, 'error');
                    }
                },
                (errMessage) => this.errorMessages = errMessage.messages);
    }
    private mapValues(): IDtoBudget {
        let budget = this.formGeneralData.value as IDtoBudget;
        budget.startDate = new Date(this.configGeneral.dateFormat(this.formGeneralData.controls['startDate'].value.singleDate.jsDate, 'mm/dd/yyyy'));
        budget.endDate = new Date(this.configGeneral.dateFormat(this.formGeneralData.controls['endDate'].value.singleDate.jsDate, 'mm/dd/yyyy'));
        budget.totalCost = this.calculateTotal();
        budget.budgetDetails = this.budgetDetails;
        budget.expenseDetails = this.expenseDetails;
        budget.bonusDetails = this.bonusDetails;
        budget.ivaPercentage = this.ivaPercentage;
        budget.userId = this.user.userId;
        if (this.action === 'update') {
            budget.id = this.budget.id;
            budget.version = this.budget.version;
            budget.versionId = this.budget.versionId;
            budget.budgetReplacedId = this.budget.budgetReplacedId;
            budget.replacementComments = this.budget.replacementComments;
            budget.creationDate = this.budget.creationDate;
            budget.approverUserId = this.budget.approverUserId;
            budget.cancellationReason = this.budget.cancellationReason;
            budget.rejectionReason = this.budget.rejectionReason;
        }
        return budget;
    }
    private setQuantity(q: number): void {
        let sum = q + +this.formCreateBudget.value.quantity;
        if (sum > 0) {
            this.formCreateBudget.get('quantity').setValue(sum);
        }
    }
    private setQuantityExpense(q: number): void {
        let sum = q + +this.formCreateExpense.value.quantity;
        if (sum > 0) {
            this.formCreateExpense.get('quantity').setValue(sum);
        }
    }
    private setDuration(q: number): void {
        let sum = q + +this.formCreateBudget.value.duration;
        if (sum > 0) {
            this.formCreateBudget.get('duration').setValue(sum);
        }
    }
    private getDate(event: IMyDateModel) {
        return event.singleDate.jsDate;
    }
  private setDateInit(date: Date) {
        this.formGeneralData.controls['startDate'].enable();
        this.formGeneralData.controls['endDate'].enable();

        const d = new Date(date);
        let model: IMyDateModel = { isRange: false, singleDate: { jsDate: d }, dateRange: null };
        this.formGeneralData.get('startDate').setValue(model);
        //this.formGeneralData.get('endDate').setValue(model);
        if (this.profile == 'Cliente') {
            this.formGeneralData.controls['startDate'].disable();
            this.formGeneralData.controls['endDate'].disable();
        }
  }
  private setDateEnd(date: Date) {
    this.formGeneralData.controls['endDate'].enable();

    const d = new Date(date);
    let model: IMyDateModel = { isRange: false, singleDate: { jsDate: d }, dateRange: null };
    this.formGeneralData.get('endDate').setValue(model);
    if (this.profile == 'Cliente') {
      this.formGeneralData.controls['endDate'].disable();
    }
  }
    private touchedControls(form: FormGroup): void {
        Object.keys(form.controls).forEach(field => {
            const control = form.get(field);
            control.markAsTouched({ onlySelf: true });
        });
    }
    private resetForm(): void {
        this.tab1.nativeElement.checked = true;
        this.action = 'add';
        this.formGeneralData.reset();
        this.formCreateBudget.reset();
        this.formCreateExpense.reset();
        this.budget = {} as IDtoBudget;
        this.budget.status = 0;
        this.budgetDetails = [] as IDtoBudgetDetail[];
        this.expenseDetails = [] as IDtoExpenseDetail[];
        this.formCreateBudget.get('quantity').setValue(1);
        this.formCreateExpense.get('quantity').setValue(1);
        this.formCreateBudget.get('discountPercentage').setValue(0);
        this.positions = null;
    }
    private openModalReason(): void {
        const initialState = {
            title: 'Motivo de rechazo',
            reason: this.budget.rejectionReason
        };
        this.modalRef = this.modalService.show(ModalReasonComponent
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.submitRejectBudget(result);
            }
        });
    }
    private openModalNotes() {
        const initialState = {
            title: `Notas del presupuesto`,
            budgetId: this.budget.id,
            status: this.budget.status
        };
        this.modalRef = this.modalService.show(ModalNotesComponet
            , Object.assign({ initialState }
                , { class: 'modal-lg' }
                , this.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
            } else {
                this.configGeneral.newToast('Error', 'Ocurrió un error al intentar guardar los datos, intente de nuevo', 'error');
            }
        });
    }
    private openModalApprovers(): void {
        const initialState = {
            title: 'Aprobadores',
            projectCustomerId: this.formGeneralData.get('projectCustomerId').value,
            customerId: this.formGeneralData.get('customerId').value,
            staffTypeName: this.customer.staffTypeName
        };
        this.modalRef = this.modalService.show(ModalBudgetApproverComponent
            , Object.assign({ initialState }
                , this.configGeneral.configModal));
        this.modalRef.content.onClose.subscribe((result) => {
            if (result) {
                this.submitSentApproval(result);
            }
        });
    }
    private addModuleLog(id: number, action: string): void {
        let dto = {} as IDtoModuleLog;
        dto.table = 'Budgets';
        dto.module = 'budgetCreation';
        dto.action = action;
        dto.registryAffectedId = id;
        this.identityService.addModuleLog(dto).subscribe(
            (x) => { });
    }
}
function groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
            map.set(key, [item]);
        } else {
            collection.push(item);
        }
    });
    return map;
}
